module.exports = __webpack_public_path__ + "static/img/cpfw-gyl3.cfbf83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-gyl3.png
// module id = AMim
// module chunks = 0